import React, { createContext, useReducer } from 'react';
import { redReducer } from './redReducer';
export const RedContext = createContext();
const initialState = {
    mktiks: [],
    autos: [],
    ipv4: [],
    emisores: [],
    naps: [],
    internet: [],
    perzo: [],
    planActivo: {},
    fabricantes: [],
    zonas: [],
    roles: [],
    dataDash: null,
    dataSpeed: [],
    //! datos de fibra
    zones: [],
    olts: [],
    planesfi: [],
    tags: [],
};
export const RedProvider = ({ children }) => {
    const [redState, dispatchRed] = useReducer(redReducer, initialState);
    return (
        <RedContext.Provider
            value={{
                redState,
                dispatchRed,
            }}>
            {children}
        </RedContext.Provider>
    );
};
